/**
 * Client-safe URL helpers shared by the composer (live link previews) and the
 * server (send-time validation, unfurl). Kept apart from `unfurl.ts`, which
 * pulls in node:net/dns and can never ship to the browser.
 */
const URL_PATTERN = /https?:\/\/[^\s<>"')\]]+/i;

/** App-owned links stay in the current WebView, even when shared as URLs. */
export function internalAppHref(raw: string): string | null {
  try {
    const url = new URL(raw, "https://app.hiive.club");
    if (
      url.protocol !== "https:" ||
      url.hostname !== "app.hiive.club" ||
      url.username ||
      url.password
    )
      return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

/** First http(s) URL in a message body, if any. */
export function extractFirstUrl(content: string | null | undefined) {
  if (!content) return null;
  const match = content.match(URL_PATTERN);
  if (!match) return null;
  try {
    return new URL(match[0]).toString();
  } catch {
    return null;
  }
}
